/* Spectral card — a pointer-tilt card with a spectral sheen, no WebGPU.
 *
 * Mirrors the vfx-ui SpectralCard contract in plain DOM:
 *   - data-tilt   max rotation in degrees (default 15)
 *   - data-glare  0..1 strength of the specular pool (default 0 = off)
 *   - data-disabled  present → no motion at all
 *   - children are ordinary markup; native links/buttons inside keep working
 *   - touch pointers and prefers-reduced-motion keep the content still
 *   - at rest nothing is applied, so the default frame is pixel-identical
 */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var coarse = window.matchMedia('(pointer: coarse)');
  var EASE = 0.12;

  function init(card) {
    if (!card || card.dataset.spBound) return;
    card.dataset.spBound = '1';

    var tilt = parseFloat(card.dataset.tilt);
    if (isNaN(tilt)) tilt = 15;
    var glare = parseFloat(card.dataset.glare);
    if (isNaN(glare)) glare = 0;
    card.style.setProperty('--sp-glare', String(Math.max(0, Math.min(1, glare))));

    var inner = card.querySelector('[data-spectral-inner]') || card.firstElementChild;
    if (!inner) return;

    var target = { x: 0.5, y: 0.5 };
    var cur = { x: 0.5, y: 0.5 };
    var active = false;
    var raf = null;

    function still() {
      return reduce.matches || coarse.matches || card.hasAttribute('data-disabled');
    }

    function frame() {
      cur.x += (target.x - cur.x) * EASE;
      cur.y += (target.y - cur.y) * EASE;
      var rx = (0.5 - cur.y) * 2 * tilt;
      var ry = (cur.x - 0.5) * 2 * tilt;
      inner.style.transform = 'rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg)';
      card.style.setProperty('--sp-x', (cur.x * 100).toFixed(1) + '%');
      card.style.setProperty('--sp-y', (cur.y * 100).toFixed(1) + '%');
      var settled = Math.abs(target.x - cur.x) < 0.0015 && Math.abs(target.y - cur.y) < 0.0015;
      if (!settled) {
        raf = requestAnimationFrame(frame);
      } else {
        raf = null;
        if (!active) inner.style.transform = '';
      }
    }
    function kick() { if (raf === null) raf = requestAnimationFrame(frame); }

    card.addEventListener('pointermove', function (e) {
      if (still() || e.pointerType === 'touch') return;
      var r = card.getBoundingClientRect();
      if (!r.width || !r.height) return;
      target.x = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width));
      target.y = Math.max(0, Math.min(1, (e.clientY - r.top) / r.height));
      if (!active) { active = true; card.classList.add('is-active'); }
      kick();
    });
    card.addEventListener('pointerleave', function () {
      target.x = 0.5; target.y = 0.5;
      active = false;
      card.classList.remove('is-active');
      kick();
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-spectral]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
